import {initPage} from "./init-page";

window.addEventListener(`load`, () => {
  initPage();
});

